export default function ContractTEPB({ isChecked, handleCheckboxChange, handleNextButtonClick }) {
  return (
    <div className="container mb100 mt100">
                <div className="beckertitlename mb100 mt100">2026 跨境資產規劃 x 美稅實務操作訓練營</div>
                <div class="card w-75 p-5 m-auto">
                <h5 class="card-title text-black text-center">購買同意事項（購買契約書）</h5>
                <div className="font-weight-blid mt-3">
                    請於報名並完成付款前詳閱下列條款。當您完成報名並完成付款，即表示本契約成立，並視為您已詳細閱讀、理解並同意遵守以下條款。
                </div>
                <div className="br mb-5 mt-3"></div>
                
                    <div class="card-body">
                        <p class="card-text m-auto">
                            <div>
                            <ul>
                                <h5 class="card-title text-black">一、本課程性質</h5>
                                <div className="font-weight-blid">
                                    「2026 跨境資產規劃 x 美稅實務操作訓練營（U.S. Tax & Estate Planning Bootcamp）」（以下簡稱「本課程」）係由捷進顧問有限公司（Direct Line Consulting Co. <br/>
                                    另稱 Becker Taiwan）（以下簡稱「本公司」）所舉辦之專業知識分享與實務操作訓練課程。<br/>
                                    本課程屬短期專業研習與培訓活動，主要內容為跨境稅務制度介紹、申報流程解析與案例實務演練。<br/>
                                    本課程並非依《短期補習班設立及管理準則》設立或管理之補習班課程，亦非學歷教育或補習教育課程。<br/>
                                    學員報名本課程，即表示了解並同意本課程之性質為專業研習與訓練活動。<br/>
                                </div>
                                <div className="br mb-5 mt-3"></div>

                                    <h5 class="card-title text-black">二、本服務內容</h5>
                                    <div className="font-weight-blid">
                                        本公司依課程規劃提供以下服務：
                                    </div>
                                    <ul>
                                        <li>講師現場授課</li>
                                        <li>課程講義或教材</li>
                                        <li>案例解析與互動討論</li>
                                        <li>跨境稅務及資產規劃相關知識教學</li>
                                    </ul>
                                
                                <div className="font-weight-blid">
                                        本課程為實體面授課程，不提供：
                                    </div>
                                
                                    <ul>
                                        <li>線上直播</li>
                                        <li>課後錄影回放</li>
                                        <li>個別法律或稅務諮詢</li>
                                        <li>投資建議或代辦服務</li>
                                    </ul>
                                    本課程內容僅供學習與專業能力提升之用，不構成法律、稅務或投資建議。
                                
                                 <div className="br mb-5 mt-3"></div>
                                <h5 class="card-title text-black">三、課程時間與形式</h5>
                                本課程採實體面授、小班互動教學方式進行。<br/>
                                課程安排如下：<br/>
                                Day 1，2026 年 4 月 11 日（星期六）<br/>
                                Day 2，2026 年 5 月 16 日（星期六）<br/>
                                課程總時數約 12 小時。<br/>
                                課程地點及詳細資訊將由本公司於開課前另行通知。<br/>
                                <div className="br mb-5 mt-3"></div>
                                <h5 class="card-title text-black">四、課程名額與報名資格</h5>
                                <ol>
                                <li>完整兩日課程名額，限額 14 名。</li>
                                <li><b>僅報名 Day 2 課程者，須持有 CPA 或 EA 專業證照</b>，並於報名時提供相關證明文件，方可完成報名並獲保留名額。</li>
                                <li>Day 2 單日課程名額，限額 5 名。</li>
                                <li>單期課程總名額，限額 14 名，按照報名清款順序保留名額。</li>
                                <li>若課程名額額滿，報名者得登記候補；若有名額釋出，本公司將於開課前通知是否候補成功。</li>
                                </ol>
                                <div className="br mb-5 mt-3"></div>
                                <h5 class="card-title text-black">五、課程費用</h5>
                                本課程費用依課程網站公告價格為準。目前課程定價如下：<br/>
                                完整兩日課程：NTD 18,000（含稅）<br/>
                                僅參加 Day 2：NTD 9,800（含稅）<br/>
                                本公司得依行銷活動提供早鳥優惠或其他促銷價格，優惠條件依活動公告為準。<br/>
                                課程費用須於報名後依指定方式完成一次性付款。未完成付款者，本公司不保留課程名額。<br/>
                                <div className="br mb-5 mt-3"></div>
                                <h5 class="card-title text-black">六、最低開班人數</h5>
                                本課程設有最低開班人數。<br/>
                                若課程報名人數未達開課標準，本公司得調整開課日期或取消課程。<br/>
                                如課程取消，學員得選擇：<br/>
                                <ul>
                                    <li>全額退費或保留名額參與後續課程場次。</li>
                                </ul>
                                <div className="br mb-5 mt-3"></div>
                                <h5 class="card-title text-black">七、退款、取消或變更課程規定（報名前請詳閱）</h5>
                                若學員因個人因素需取消、變更或申請退費，應依下列規定辦理：
                                <ol>
                                    <li>開課日前七日（含）以前</li>
                                    學員如於開課日前七日（含）以前以書面方式通知本公司（包含發送電子郵件通知 service@beckertw.com 或發訊通知 Becker Taiwan LINE 官方帳號訊息），得取消課程並辦理全額退費。<br/>
                                    <div className="br mb-5 mt-3"></div>

                                    <li>開課日前三日至六日</li>
                                    學員如於開課日前三日至六日（含）期間通知本公司取消或變更課程者，得選擇下列方式之一辦理：<br/>
                                    （一）退還已繳課程費用 40%；或<br/>
                                    （二）另行支付 10% 原課程費用作為課程異動費用，並得於本公司日後開設之同類型課程中擇期補課一次。<br/>
                                <div className="br mb-5 mt-3"></div>

                                    <li>開課日前三日內</li>
                                    學員如於開課日前三日內提出取消或變更申請者：<br/>
                                    （一）不得申請退費；<br/>
                                    （二）但得將課程名額轉讓予他人一次（須事先通知本公司並完成學員資料變更）；<br/>
                                    （三）或另行支付 30% 原課程費用作為課程異動費用，並得於本公司日後開設之同類型課程中擇期補課一次。<br/>
                                <div className="br mb-5 mt-3"></div>

                                    <li>課程當日未到課</li>
                                    若學員於課程當日未到課，視為已使用課程服務，恕不接受退費或補課申請。<br/>
                                <div className="br mb-5 mt-3"></div>

                                    <li>補課期限</li>
                                    補課須於原課程開課日起 一年內完成，逾期視同放棄補課權利。<br/>
                                    補課須依本公司後續課程名額狀況安排，本公司不保證特定場次之名額。
                                <div className="br mb-5 mt-3"></div>

                                    <li>開課日之定義</li>
                                    本契約所稱「開課日」，係指實際課程開始之日期：<br/>
                                    完整兩日課程學員：開課日為 2026 年 4 月 11 日（星期六）<br/>
                                    僅報名 Day 2 課程學員：開課日為 2026 年 5 月 16 日（星期六）
                                </ol>
                                <div className="br mb-5 mt-3"></div>
                                <h5 class="card-title text-black">八、名額轉讓</h5>
                                學員如無法參加課程，得於課程開始前通知本公司，並將課程名額轉讓予他人一次。<br/>
                                受讓人須符合本課程報名資格。<br/>
                                若為 Day 2 課程，受讓人仍須符合 CPA 或 EA 專業證照資格。
                                <div className="br mb-5 mt-3"></div>
                                <h5 class="card-title text-black">九、智慧財產權</h5>
                                本課程所有教材、講義、投影片及相關資料之智慧財產權，均屬捷進顧問有限公司或授課講師所有。<br/>
                                學員僅得為個人學習目的使用，不得：<br/>
                                <ul>
                                    <li>錄音</li>
                                    <li>錄影</li>
                                    <li>語音轉錄</li>
                                    <li>逐字紀錄 (scribe)</li>
                                    <li>翻印</li>
                                    <li>轉載</li>
                                    <li>上傳網路</li>
                                    <li>散布或轉售課程內容</li>
                                    如有侵權行為，本公司將依法追究相關民刑事責任。
                                </ul>
                                <div className="br mb-5 mt-3"></div>
                                <h5 class="card-title text-black">十、課程秩序</h5>
                                學員於課程期間應遵守教學秩序及場地規範。<br/>
                                若學員行為嚴重影響課程進行，本公司得要求其離場，且不予退費。<br/>
                                <div className="br mb-5 mt-3"></div>
                                <h5 class="card-title text-black">十一、隱私權聲明</h5>
                                本公司依個人資料保護法蒐集學員於報名時提供之資料，包括：<br/>
                                <ul>
                                    <li>姓名</li>
                                    <li>電子郵件</li>
                                    <li>聯絡電話</li>
                                    <li>付款資訊</li>
                                </ul>
                                使用目的包括：<br/>
                                <ul>
                                    <li>課程報名管理</li>
                                    <li>客戶服務</li>
                                    <li>課程通知</li>
                                    <li>行銷資訊通知</li>
                                </ul>
                                本公司將於服務存續期間或法律規定之保存期限內利用該資料。<br/>
                                如需行使個資相關權利，請來信：service@beckertw.com<br/>
                                <div className="br mb-5 mt-3"></div>
                                <h5 class="card-title text-black">十二、課程異動</h5>
                                若因不可抗力因素（如天災、疫情、政府命令或講師不可抗力因素）導致課程無法如期舉辦，本公司得調整課程日期或形式。<br/>
                                如課程需延期或取消，本公司將提前通知學員。<br/>
                                <div className="br mb-5 mt-3"></div>
                                <h5 class="card-title text-black">十三、購買資格</h5>
                                購買本課程者應為：<br/>
                                <ul>
                                    <li>具有完全行為能力之人；</li>
                                    <li>已取得法定代理人同意之限制行為能力人。</li>
                                </ul>
                                <div className="br mb-5 mt-3"></div>
                                <h5 class="card-title text-black">十四、管轄法院</h5>因本契約所生之一切爭議，雙方同意以臺灣臺北地方法院為第一審管轄法院，但不得排除消費者保護法或民事訴訟法有關小額訴訟管轄法院之適用。
                                <div className="br mb-5 mt-3"></div>
                                捷進顧問有限公司<br/>
                                Direct Line Consulting Co.<br/>
                                電話：02-2700-0053<br/>
                                客服信箱：service@beckertw.com<br/>
                                地址：台北市大安區信義路四段6號16樓之12<br/>
                                統一編號：80523352<br/>
                            </ul>
                        </div>
                    </p>
                    <div className="text-center">
                        <label>
                            <input className="m-2" type="checkbox" value="read" checked={isChecked} onChange={handleCheckboxChange} required />
                            <span>我已詳閱並且了解</span>
                        </label>
                        <div className="btn btn-primary m-3" onClick={handleNextButtonClick}>下一步</div>
                    </div>
                    </div>
                </div>
            </div>
  );
}
